import { camelCase, snakeCase } from "lodash";

export const isEmpty: any = (obj: {} | any) => {
  return Object.keys(obj).length === 0;
};

export const camelize: any = (data: any) => {
  if (Array.isArray(data)) {
    return data.map(camelize);
  } else if (data !== null && typeof data === "object") {
    return Object.keys(data).reduce(
      (value, key) => ({
        ...value,
        [camelCase(key)]: camelize(data[key]),
      }),
      {}
    );
  }

  return data;
};

export const snakelize: any = (data: any) => {
  if (Array.isArray(data)) {
    return data.map(snakelize);
  } else if (data !== null && typeof data === "object") {
    return Object.keys(data).reduce(
      (value, key) => ({
        ...value,
        [snakeCase(key)]: snakelize(data[key]),
      }),
      {}
    );
  }

  return data;
};

export const areAllValuesOverLength = (obj, length) => {
  return Object.values(obj).every((value: any) => value.length > length);
};

export const deepCopy = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  const newObj = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepCopy(obj[key]);
    }
  }

  return newObj;
}